import "./ProductCatalog.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import CatalogHero from "./sections/CatalogHero";
import Catalog from "./sections/Catalog";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function ProductCatalogPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="ProductCatalog" />
      <CatalogHero />
      <Catalog />
      <QuoteCTA />
      <Footer />
    </div>;
}